export enum HHDSButtonType {    
    Primary = 'primary',
    Secondary = 'secondary',
    Overlay = 'overlay',
    ScrollDown = 'scroll-down',
    Round = 'round',
}